// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Shared display utilities for findings change types.
 * Single source of truth for change labels and display text formatting.
 */
import type { ChangeType } from '../types'

/** Human-readable labels for each change type */
export const CHANGE_LABELS: Record<ChangeType, string> = {
  append: 'Add at End',
  prepend: 'Add at Start',
  replace_phrase: 'Replace Phrase',
  delete_phrase: 'Delete',
  full_replace: 'Replace With',
}

/** Get label for a change type */
export function getChangeLabel(changeType: ChangeType): string {
  return CHANGE_LABELS[changeType]
}

/** Format change text for display based on change type */
export function getChangeDisplayText(
  changeType: ChangeType,
  changeText: string | null,
  targetPhrase: string | null
): string {
  switch (changeType) {
    case 'replace_phrase':
      return `"${targetPhrase}" → "${changeText}"`
    case 'delete_phrase':
      return `"${targetPhrase}"`
    default:
      return changeText ?? ''
  }
}
